import { Component, OnInit } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { LocalService } from "../../../../core";

@Component({
  selector: "app-account-activity-content",
  templateUrl: "./account-activity-content.component.html",
  styleUrls: ["./account-activity-content.component.scss"]
})
export class AccountActivityContentComponent implements OnInit {
  selectedTabName: string = "pointsActivityTab";
  activityTabs: any[] = [];
  userProfile: any;
  isCiscoAdmin: boolean = false;

  constructor(private translate: TranslateService) {}

  ngOnInit(): void {
    this.userProfile = LocalService.get("userProfile");
    this.checkIfCiscoAdmin();
    this.buildActivityTabs();
  }

  checkIfCiscoAdmin(): void {
    if (this.userProfile && this.userProfile.roles) {
      this.isCiscoAdmin = this.userProfile.roles.find((item: any) => item.name === "COMPANY_ADMIN") ? true : false;
    }
  }

  buildActivityTabs(): void {
    this.activityTabs = [
      {
        title: this.translate.instant('accountDetails.pointsActivity'),
        subtitle: this.translate.instant('accountDetails.pointsActivitySubtitle'),
        tabId: 'pointsActivityTab',
        isVisible: true
      },
      {
        title: this.translate.instant('accountDetails.userPointSummary'),
        subtitle: this.translate.instant('accountDetails.userPointSummarySubtitle'),
        tabId: 'userPointSummaryTab',
        isVisible: false
      },
      {
        title: this.translate.instant('accountDetails.redeemReport'),
        subtitle: this.translate.instant('accountDetails.redeemReportSubtitle'),
        tabId: 'redeemReportTab',
        isVisible: true
      },
      {
        title: this.translate.instant('accountDetails.cashPayment'),
        subtitle: this.translate.instant('accountDetails.cashPaymentSubtitle'),
        tabId: 'cashPayment',
        isVisible: this.isCiscoAdmin
      }
    ];
  }

  onActivityTabClicked(event: { tabId: string }): void {
    this.selectedTabName = event.tabId;
  }
}
